import { UiBadge } from "@/components/ui/elements";

import {
  getJobOfferTagBadgeVariant,
  isHiddenJobOfferTag,
} from "../_function/jobOfferBadgeVariant";

const LIMITED_OFFER_TAG = "限定オファー";

type Props = {
  tag: string;
  muted?: boolean;
};

/** 求人タグ専用バッジ（タグ文字列から色を自動推定） */
export function JobOfferTagBadge({ tag, muted = false }: Props) {
  if (isHiddenJobOfferTag(tag)) return null;

  const uiVariant =
    muted && tag !== LIMITED_OFFER_TAG
      ? "gray"
      : getJobOfferTagBadgeVariant(tag);

  return (
    <UiBadge uiVariant={uiVariant} size="sm">
      {tag}
    </UiBadge>
  );
}
